// §14.5 Number & Currency Formatting — exactly 2 decimals, dot for
// thousands, comma for decimals, currency symbol before the amount.
export const fmtEUR = (v) => {
  const n = Number(v) || 0;
  const sign = n < 0 ? '-' : '';
  const [int, dec] = Math.abs(n).toFixed(2).split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `€ ${sign}${grouped},${dec}`;
};

export const fmtInt = (v) => {
  const n = Math.round(Number(v) || 0);
  const sign = n < 0 ? '-' : '';
  return sign + Math.abs(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const timeAgo = (input) => {
  if (!input) return '';
  const then = new Date(input).getTime();
  if (!Number.isFinite(then)) return '';
  const sec = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (sec < 60) return 'Just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hrs = Math.floor(min / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? '' : 's'} ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`;
  return new Date(then).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
};
